import { useContext } from 'react';

import { StateContext } from './state-context';
import type { PanelSystemState } from './types';

/**
 * Hook to access the panel system state from context.
 * Must be called within a PanelProvider.
 *
 * Consumers of this hook will re-render when state changes.
 *
 * @throws {Error} If called outside of a PanelProvider
 * @internal
 */
export function usePanelStateInternal(): PanelSystemState {
	const state = useContext(StateContext);

	if (!state) {
		throw new Error(
			'usePanelStateInternal must be used within a <PanelProvider>. ' +
				'Wrap your app with: <PanelProvider><App /></PanelProvider>',
		);
	}

	return state;
}
